export default __webpack_public_path__ + "static/media/tata.a0929c19.jpg";